/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import type { Box_WidgetRpcActionType as WidgetRpcActionType } from '__generated__/graphql-types';

import WidgetFrame from 'bundles/widget/components/cds/WidgetFrame';

type Props = {
  source: string;
  sandbox: string;
  iframeTitle: string;
  rpcActionTypes: WidgetRpcActionType[];
  expiresAt: number;
  sessionId: string;
  reviewResponseId: string;
};

const styles = {
  container: css`
    height: 100%;
  `,
};

export const InlineSubmissionTool = ({
  source,
  sandbox,
  iframeTitle,
  rpcActionTypes,
  expiresAt,
  sessionId,
  reviewResponseId,
}: Props) => {
  return (
    <div className="rc-InlineSubmissionTool" css={styles.container}>
      <WidgetFrame
        session={{
          src: source,
          sandbox,
          iframeTitle,
          rpcActionTypes,
          expiresAt,
        }}
        sessionId={sessionId}
        widgetId={`box-inline-feedback-${reviewResponseId}`}
        // aligns with in-frame boxview actions in expanded state
        modalHeaderCss={{ paddingRight: '20px' }}
        showPopupButton={true}
      />
    </div>
  );
};

export default InlineSubmissionTool;
